// import PropTypes from 'prop-types';
import {PureComponent} from 'react';
import GoogleMapReact from "google-map-react";
import * as ReactDOMServer from 'react-dom/server';
import pinBigImage from '../../public/assets/images/global/pin.svg';
import pinBigImageSelected from '../../public/assets/images/global/pinSelected.svg';
import media from "Util/Media/Media";
import history from 'Util/History';

export const MARKER_ICON_PATH = 'ideo/storelocator/markericon/';
export const SELECTED_MARKER_ICON_PATH = 'ideo/storelocator/selected_markericon/';

import './GoogleMap.style';

const markerStyle = {
    position: "absolute",
    top: "100%",
    left: "50%",
    transform: "translate(-50%, -100%)",
    height: "21px",
    width: "32px"
};

export class GoogleMap extends PureComponent {

    render() {
        const {
            items,
            map_markericon,
            map_selected_markericon,
            map_style,
            selectStore,
            addMarkerRef,
            google_api_key,
            map_zoom,
            mapOptions = {}
        } = this.props;

        let defaultZoom = 2;
        let defaultLat = 38.000275;
        let defaultLng = 23.733576;
        if (items.length !== 0) {
            defaultLat = parseFloat(items[0].lat);
            defaultLng = parseFloat(items[0].lng);
        }

        return (
            // Important! Always set the container height explicitly
            <div style={{height: "25vh", width: "100%"}}>
                <GoogleMapReact
                    options={
                        {
                            ...{
                                styles: map_style ? JSON.parse(map_style) : []
                            },
                            ...mapOptions
                        }
                    }
                    onTilesLoaded={()=>{
                        setTimeout(()=>{
                            let map = window.map;
                            let icon = map_markericon ? media(map_markericon, MARKER_ICON_PATH) : pinBigImage;
                            if (items.length === 1)
                                icon = map_selected_markericon ? media(map_selected_markericon, SELECTED_MARKER_ICON_PATH) : pinBigImageSelected;
                            items.map(item => {
                                let marker = new google.maps.Marker({
                                    position: new google.maps.LatLng(item.lat, item.lng),
                                    map: map,
                                    icon: icon
                                });
                                addMarkerRef(item.store_id, marker);
                                let originPath = window.location.origin;
                                let storeCode = window.location.pathname.split('/')[1];
                                let popupContent = ReactDOMServer.renderToStaticMarkup(
                                    <>
                                        <div className="shop-list__title">{item.name}</div>
                                        <div className="shop-list__text"><p>{item.address}</p>
                                            {
                                                item.phone && <p>{__('Τηλέφωνο : %s', item.phone)}</p>
                                            }
                                        </div>
                                        <a href={originPath + "/" + storeCode + "/" + item.url_alias} className={'shop-list__link'}>
                                            {__("Δείτε περισσότερα")}
                                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6 12.5L10 8.5L6 4.5" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </a>
                                    </>
                                );
                                google.maps.event.addListener(marker, 'click', function () {
                                    var infowindow = new google.maps.InfoWindow({
                                        content: popupContent
                                    });
                                    infowindow.open(map, this);
                                    selectStore(item);
                                });
                            });
                        },2000)
                    }}
                    onGoogleApiLoaded={({map, maps}) => {
                        window.map = map;
                    }}
                    bootstrapURLKeys={{
                        key: google_api_key ? google_api_key : "AIzaSyA16d9FJFh__vK04jU1P64vnEpPc3jenec"
                    }}
                    defaultCenter={{lat: defaultLat, lng: defaultLng}}
                    defaultZoom={map_zoom ? parseInt(map_zoom) :defaultZoom}
                >
                </GoogleMapReact>
            </div>
        );
    }
}

export default GoogleMap;
